import state from './clubs.states'
import getters from './clubs.getters'
import mutations from './clubs.mutations'
import actions from './clubs.actions'

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/clubs/index.js